import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import { registryCombineReducer } from 'mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/combineRegistry';

import TasksExecReportForm from './TasksExecReportForm';
import TasksExecAnswerConfirmForm from './TasksExecAnswerConfirmForm';
import TasksExecRefuseForm from './TasksExecRefuseForm';
import TasksExecMessageForm from './TasksExecMessageForm';
import TasksExecDisputeForm from './TasksExecDisputeForm';

const tabReport = 'tabReport';
const tabRefuse = 'tabRefuse';
const tabMessage = 'tabMessage';
const tabDispute = 'tabDispute';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecsFormsBlockAsExecutor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabActive: [1, 3].includes(props.exec.status) ? tabReport : null,
      formReduceName: `taskExecExecutorForms-${props.exec.id}`
    };
    registryCombineReducer(this.state.formReduceName);
  }

  closeAllTabs = () => {
    this.setState({ tabActive: null });
  };

  hasTabReportDisabled = () => ![1, 3].includes(this.props.exec.status);
  hasTabMessageDisabled = () => false;
  hasTabRefuseDisabled = () => ![1, 2, 3].includes(this.props.exec.status);
  hasTabDisputeDisabled = () => ![1, 2, 3, 8].includes(this.props.exec.status);

  handleChangeTab = (e, name) => {
    e.preventDefault();
    if (
      (name === tabReport && !this.hasTabReportDisabled()) ||
      (name === tabMessage && !this.hasTabMessageDisabled()) ||
      (name === tabRefuse && !this.hasTabRefuseDisabled()) ||
      (name === tabDispute && !this.hasTabDisputeDisabled())
    ) {
      if (name === this.state.tabActive) {
        this.setState({ tabActive: null });
      } else {
        this.setState({ tabActive: name });
      }
    }
  };

  render() {
    if ([4, 5, 6].includes(this.props.exec.status)) {
      return null;
    }

    const tabReportDisabledDesc = this.hasTabReportDisabled()
      ? t('Вы уже отправили отчет о проделанной работе')
      : null;
    const tabRefuseDisabledDesc = this.hasTabRefuseDisabled()
      ? t('Нельзя отказаться от работы в текущем состоянии выполнения')
      : null;
    const tabMessageDisabledDesc = '';
    const tabDisputeDisabledDesc = this.hasTabDisputeDisabled()
      ? t('Нельзя обратиться в арбитраж в текущем состоянии выполнения')
      : null;

    const tabActiveClass = tabActive => {
      switch (this.state.tabActive) {
        case tabActive:
          return 'active';
        default:
          return '';
      }
    };

    const tabContent = () => {
      switch (this.state.tabActive) {
        case tabReport: {
          if (this.props.exec.checkType === 2) {
            return (
              <TasksExecAnswerConfirmForm
                {...this.props}
                closeAllTabs={this.closeAllTabs}
                formReduceName={this.state.formReduceName}
              />
            );
          }
          return (
            <TasksExecReportForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        }
        case tabRefuse:
          return (
            <TasksExecRefuseForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabMessage:
          return (
            <TasksExecMessageForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        case tabDispute:
          return (
            <TasksExecDisputeForm
              {...this.props}
              closeAllTabs={this.closeAllTabs}
              formReduceName={this.state.formReduceName}
            />
          );
        default:
          return null;
      }
    };
    return (
      <div data-toggle="tab-close-click-out" className="active">
        <div className="panel-bar bg-main">
          <ul className="nav nav-tabs nav-tabs-lg">
            <li
              className={`pull-right ${tabActiveClass(tabReport)}${
                this.hasTabReportDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title=""
              data-original-title={tabReportDisabledDesc}
            >
              <a
                href=""
                className="text-primary"
                onClick={e => {
                  this.handleChangeTab(e, tabReport);
                }}
              >
                <i className="fa fa-file-text" /> {t('Отчет')}
              </a>
            </li>
            <li
              className={`pull-right ${tabActiveClass(tabRefuse)}${
                this.hasTabRefuseDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title={tabRefuseDisabledDesc}
              data-original-title={tabRefuseDisabledDesc}
            >
              <a
                href=""
                className="text-danger"
                onClick={e => {
                  this.handleChangeTab(e, tabRefuse);
                }}
              >
                <i className="fa fa-times-circle" /> {t('Отказаться')}
              </a>
            </li>
            <li
              className={`pull-right ${tabActiveClass(tabMessage)}${
                this.hasTabMessageDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title={tabMessageDisabledDesc}
              data-original-title={tabMessageDisabledDesc}
            >
              <a
                className="text-muted"
                data-toggle="tab"
                href=""
                aria-expanded="true"
                onClick={e => {
                  this.handleChangeTab(e, tabMessage);
                }}
              >
                <i className="fa fa-comment" /> {t('Сообщение')}
              </a>
            </li>
            <li
              className={`pull-left ${tabActiveClass(tabDispute)}${
                this.hasTabDisputeDisabled() ? ' disabled' : ''
              }`}
              data-toggle="tooltip"
              title={tabDisputeDisabledDesc}
              data-original-title={tabDisputeDisabledDesc}
            >
              <a
                className="text-muted"
                data-toggle="tab"
                href=""
                aria-expanded="true"
                onClick={e => {
                  this.handleChangeTab(e, tabDispute);
                }}
              >
                <span className="text-warning">
                  <i className="fa fa-gavel" />
                </span>{' '}
                {t('Арбитраж')}
              </a>
            </li>
          </ul>
        </div>
        <div className="tab-content">{tabContent()}</div>
      </div>
    );
  }
}

TasksExecsFormsBlockAsExecutor.propTypes = {
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired,
    checkType: PropTypes.number.isRequired,
    status: PropTypes.number.isRequired,
    statusName: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(TasksExecsFormsBlockAsExecutor);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecsFormsBlockAsExecutor.js